import {observer, React} from '@api';
import {Tooltip2} from '@api'
import {useStores} from '@modules/VipLocalStore'
import { PdfSvgIcon } from '@stores/ui';
import {PrimaryIconButton} from 'centric-ui-components';

export const PdfMenuButton = observer(function PdfMenuButton( ) {
  const {strings, catalog: {toggleShowPdf, isShowingClientPDF, pdfConfig}} = useStores()

  // if (!pdfConfig?.templates?.length) { return null }

  return <Tooltip2 content={strings.pdfView} placement='bottom'>
    <PrimaryIconButton icon={<PdfSvgIcon/>}
                       active={isShowingClientPDF}
                       onClick={toggleShowPdf}/>
  </Tooltip2>
})



// WEBPACK FOOTER //
// ./src/modules/siteHeader/components/PdfMenuButton.tsx